import {
  GetCustomResourceFieldsDocument,
  GetCustomResourceFieldsQueryVariables,
} from 'generated/resources/graphql'

import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

export const useCustomResourceFields = (
  variables: Omit<GetCustomResourceFieldsQueryVariables, 'after'>
) => {
  const { nodes, controls, loading } = usePaginatedQuery(GetCustomResourceFieldsDocument, {
    variables,
    extractConnection: (data) => data.customFields.resourceFieldsConnection,
  })

  return {
    loading,
    customResourceFields: nodes,
    controls,
  }
}
